'use strict';

angular.module('ClinicApp').config(function($stateProvider) {
  $stateProvider.state('doctor.profile', {
    url: 'profile/',
    templateUrl: '/views/partials/doctor/profile.html',
    controller: 'DoctorProfileCtrl',
    resolve: {
      pageTitle: function($pageTitle, doctor) {
        $pageTitle.set('About - ' + doctor.name + ' - Opencare');
      },
      languages: function(LanguageService) {
        return LanguageService.listLanguages();
      },
      questions: function(QuestionService) {
        return QuestionService.listDoctorQuestions();
      },
    },
  });
});

angular.module('ClinicApp').controller('DoctorProfileCtrl', function($scope, languages, DoctorService, questions, OpencareConstants, GenderConstants, QuestionService, OCValidationUtil, UserService, doctor, CurrentUser) {
  OpencareAnalytics.trackPageView({
    pageType: OpencareAnalytics.pageTypes.PROFILE_MANAGER,
    pageName: doctor.name,
    content: {
      view: 'provider',
      is_real_practice: String(!CurrentUser.isImpersonated()),
    },
    doctorId: doctor.id,
    userId: CurrentUser.getUser().id,
  });

  $scope.genderList = GenderConstants.genderList;
  $scope.languageList = languages;
  $scope.specialtyList = OpencareConstants.specialties;

  if (!$scope.doctor.gender) {
    $scope.doctor.gender = '';
  }

  $scope.questions = questions;
  $scope.responsesByQuestion = _.indexBy($scope.doctor.questionResponses, function(response) {
    return response.question.id;
  });

  $scope.userSelected = {
    languageIds: _.pluck($scope.doctor.languages, 'id'),
    languageNames: [],
    specialtyIds: _.pluck($scope.doctor.specialties, 'id'),
    specialtyNames: [],
  };

  refreshLanguageNames();
  refreshSpecialtyNames();

  $scope.$watchCollection('userSelected.languageIds', function() {
    refreshLanguageNames();
  });
  $scope.$watchCollection('userSelected.specialtyIds', function() {
    refreshSpecialtyNames();
  });

  // Check if gender is empty, reject if it is
  $scope.validateGenders = function(data) {
    if (_.isEmpty(data)) {
      return 'Gender cannot be blank';
    }
  };

  $scope.updateDoctor = function() {
    return DoctorService.updateDoctor($scope.doctor, {
      name: $scope.doctor.name,
      gender: $scope.doctor.gender || null,
      about: $scope.doctor.about,
    }).then(function() {
      $scope.$emit('reloadDoctor');
    });
  };

  // Check if new data is empty, reject if it is
  $scope.validateLanguages = function(data) {
    if (_.isEmpty(data)) {
      return 'You must select at least one language';
    }
  };

  $scope.updateDoctorLanguages = function() {
    return DoctorService.synchronizeLanguages($scope.doctor.id, _.pluck($scope.doctor.languages, 'id'), $scope.userSelected.languageIds).then(function() {
      $scope.$emit('reloadDoctor');
    });
  };

  $scope.validateSpecialties = function(data) {
    if (_.isEmpty(data)) {
      return 'You must select at least one specialty';
    }
  };

  $scope.updateDoctorSpecialty = function() {
    return DoctorService.synchronizeSpecialties(_.pluck($scope.doctor.specialties, 'id'), $scope.userSelected.specialtyIds, $scope.doctor.id).then(function() {
      $scope.$emit('reloadDoctor');
    });
  };

  $scope.getQuestionResponse = function(question) {
    if (!$scope.responsesByQuestion[question.id]) {
      $scope.responsesByQuestion[question.id] = {
        response: '',
      };
    }
    return $scope.responsesByQuestion[question.id];
  };

  $scope.saveQuestionResponse = function(question, responseText) {
    if ($scope.waitingQuestionResponse) {
      return;
    }
    $scope.waitingQuestionResponse = true;
    return QuestionService.respond(question.id, question.modelType, $scope.doctor.id, responseText)
      .then(() => {
        $scope.$emit('reloadDoctor');
      })
      .finally(() => {
        $scope.waitingQuestionResponse = false;
      });
  };

  $scope.checkEmail = function(email) {
    if (!email || !OCValidationUtil.isValidEmail(email)) {
      return 'Please enter a valid email address.';
    }
  };

  $scope.updateEmail = function() {
    var err = $scope.checkEmail($scope.doctor.email);
    if (err) {
      return err;
    }
    return DoctorService.updateDoctor($scope.doctor, {
      email: $scope.doctor.email,
    }).then(function() {
      $scope.$emit('reloadDoctor');
    });
  };

  // Check if name is empty, reject if it is
  $scope.validateName = function(data) {
    if (!data || _.trim(data) === '') {
      return 'Name cannot be blank';
    }
  };

  $scope.updateName = function() {
    if (!$scope.doctor.name) {
      return null;
    }
    return DoctorService.updateDoctor($scope.doctor, {
      name: $scope.doctor.name,
    }).then(function() {
      $scope.$emit('reloadDoctor');
    });
  };

  $scope.resendEmailVerification = function($event) {
    $event.stopPropagation();
    return UserService.sendEmailVerification($scope.doctor.email);
  };

  function refreshLanguageNames() {
    var languagesSelected = _.filter($scope.languageList, function(language) {
      return $scope.userSelected.languageIds.indexOf(language.id) >= 0;
    });
    $scope.userSelected.languageNames = _.pluck(languagesSelected, 'name');
  }

  function refreshSpecialtyNames() {
    var specialtiesSelected = _.filter($scope.specialtyList, function(specialty) {
      return $scope.userSelected.specialtyIds.indexOf(specialty.id) >= 0;
    });
    $scope.userSelected.specialtyNames = _.pluck(specialtiesSelected, 'specialty');
  }
});
